import cataloger from '@/router/routes/cataloger';
import common from '@/router/routes/common';

/**
 * This will return the routes for the specified module
 * @param {string} nameOfModuleToLoad - The name of the module to load
 * @returns an array of routes
 */
 export default function assignModuleRoutes(nameOfModuleToLoad) {
  const modulesRoutes = [
    ...common,
    ...cataloger,
  ];
  const materialRouteIndex = modulesRoutes.findIndex(route => route.name === 'materials');
  const materialChildren = modulesRoutes[materialRouteIndex].children;
  const materialRequestIndex = materialChildren.findIndex(route => route.name === 'materials.requests');
  const materialCreateIndex = materialChildren.findIndex(route => route.name === 'materials.create');
  const newMaterialRequestRoute = materialChildren[materialRequestIndex];
  const newMaterialCreateRoute = materialChildren[materialCreateIndex];
  newMaterialRequestRoute.component = () => import(/* webpackChunkName: "solicitudesMaterial" */`@/pages/cataloger/${nameOfModuleToLoad}/SolicitudesMateriales`);
  newMaterialCreateRoute.component = () => import(/* webpackChunkName: "etapasMateriales" */`@/pages/cataloger/${nameOfModuleToLoad}/stages`);
  materialChildren[materialRequestIndex] = newMaterialRequestRoute;
  materialChildren[materialCreateIndex] = newMaterialCreateRoute;
  modulesRoutes[materialRouteIndex].children = materialChildren;
  return modulesRoutes;
}



// WEBPACK FOOTER //
// ./src/store/modules/cataloger/assignModuleRoutes.js